import {RequestType, UyapRequest} from "./UyapRequest";

export interface AvukatKisiselBilgileriSorgulamaTalep {
}

export interface AvukatKisiselBilgileriSorgulamaCevap {
    avukatBilgileri: {
        avukatId: number,
        kisiKurumId: number,
        tcKimlikNo: string,
        ad: string,
        soyad: string,
        babaAd: string,
        anaAd: string,
        dogumTarihi: string,
        dogumYeri: string,
        mernisGuncellemesiYapildi: boolean,
        isTCGecerli: boolean,
        vekilTipiKod: string,
        baroNo: number,
        tbbNo: string,
        bagliOlduguBaroAdi: string,
        vergiNo: string,
        adresList: Array<any>,
        kamuAvukatiMi: boolean,
        isMock: boolean
    },
    portalBakiye: {
        hasBarokart: boolean,
        sorguToplamIslemSayisi: number,
        sorguKalanIslemSayisi: number,
        ucretsizSorguLimit: number
    },
    sorguBakiye: {
        sorguBakiye: number,
        hasBarokart: boolean,
        sorguToplamIslemSayisi: number,
        sorguKalanIslemSayisi: number,
        ucretsizSorguLimit: number
    }
}

export default class AvukatKisiselBilgileriSorgulama extends UyapRequest<AvukatKisiselBilgileriSorgulamaTalep, AvukatKisiselBilgileriSorgulamaCevap> {
    delayTime = 0;

    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    cache() {
        return {
            active: false,
            ttl: (60 * 24), //* 1 gun
            key: "AvukatKisiselBilgileriSorgulama"
        };
    }

    getMockResponse(): any {
        return [
            {
                "avukatId": 111111,
                "kisiKurumId": 1111111,
                "tcKimlikNo": "11111111110",
                "ad": "N____",
                "soyad": "E_____",
                "babaAd": "R____",
                "anaAd": "A____",
                "dogumTarihi": "11/08/1956",
                "dogumYeri": "ANKARA",
                "mernisGuncellemesiYapildi": false,
                "isTCGecerli": true,
                "vekilTipiKod": "BARO",
                "baroNo": 12345,
                "tbbNo": "12345",
                "bagliOlduguBaroAdi": "ANKARA 1 NOLU BAROSU",
                "vergiNo": "11111111110",
                "adresList": [],
                "kamuAvukatiMi": false,
                "isMock": false
            },
            {
                "hasBarokart": false,
                "sorguToplamIslemSayisi": 0,
                "sorguKalanIslemSayisi": 0,
                "ucretsizSorguLimit": 0
            },
            {
                "sorguBakiye": 1,
                "hasBarokart": false,
                "sorguToplamIslemSayisi": 0,
                "sorguKalanIslemSayisi": 0,
                "ucretsizSorguLimit": 0
            }
        ]
    }

    getRequestType(): RequestType {
        return "json";
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'avukatKisiselBilgileriSorgula.ajx';
    }

    async parse(data: any): Promise<AvukatKisiselBilgileriSorgulamaCevap> {
        return {
            avukatBilgileri: data[0],
            portalBakiye: data[1],
            sorguBakiye: data[2]
        }
    }
}